import api from "./api";

const CommonAPI = {
    getColumnSetting: (tableKey) => api.get(`/common/column-setting/${tableKey}`),
    insUpdColumnSetting: (params) => api.post(`/common/column-setting`, params),
    getAppRoute: () => api.get(`/common/app-route`),
    getAppRouteById: (id) => api.get(`/common/app-route/${id}`),
    appRouteInsert: (data) => api.post(`/common/app-route/insert`, data),
    appRouteUpdate: (data) => api.post(`/common/app-route/update`, data),
    appRouteDelete: (id) => api.delete(`/common/app-route/delete/${id}`),
    getUploadFile: (fileName) => api.get(`/common/uploads/file/${fileName}`, {
        responseType: "blob"
    }),
    getAssetsFile: (folder, fileName) => api.get(`/common/assets/file/${folder}/${fileName}`, {
        responseType: "blob"
    }),
};

export default CommonAPI;